import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => {
  return (
    <footer className="relative bg-cometa-tinta text-cometa-crema">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid gap-12 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <Logo variant="light" showLicencia />
          <p className="mt-6 text-cometa-crema/70 max-w-md leading-relaxed">
            Un movimiento para acercar realidades, conectar mundos y activar posibilidades.
            Generamos conciencia para convertirla en acción.
          </p>
          <p className="mt-6 font-script text-3xl text-cometa-dorado">¿Cuál es tu utopía?</p>
        </div>
        <div>
          <h5 className="text-xs tracking-[0.3em] text-cometa-crema/50 mb-4">EXPLORA</h5>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/cometa" className="link-underline">Nuestra historia</Link></li>
            <li><Link to="/podcast" className="link-underline">Podcast</Link></li>
            <li><Link to="/blog" className="link-underline">Blog</Link></li>
            <li><Link to="/tejido" className="link-underline">Tejido de Utopías</Link></li>
            <li><Link to="/constelacion" className="link-underline">Constelación de Utopías</Link></li>
            <li><Link to="/marca" className="link-underline">Utopistas</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="text-xs tracking-[0.3em] text-cometa-crema/50 mb-4">CONTACTO</h5>
          <ul className="space-y-2.5 text-sm">
            <li><a href="mailto:contacto@dracometa.com.mx" className="link-underline">contacto@dracometa.com.mx</a></li>
            <li><a href="https://wa.me/525528980641" target="_blank" rel="noreferrer" className="link-underline">+52 55 2898 0641</a></li>
          </ul>
          <div className="flex gap-4 mt-6">
            <a data-testid="social-instagram" href="https://www.instagram.com/doctora_cometa" target="_blank" rel="noreferrer" aria-label="Instagram" className="p-2 rounded-full border border-cometa-crema/20 hover:bg-cometa-crema hover:text-cometa-tinta transition"><Instagram size={18} /></a>
            <a data-testid="social-tiktok" href="https://www.tiktok.com/@dra..cometa" target="_blank" rel="noreferrer" aria-label="TikTok" className="p-2 rounded-full border border-cometa-crema/20 hover:bg-cometa-crema hover:text-cometa-tinta transition text-sm font-bold">Tk</a>
            <a data-testid="social-facebook" href="https://www.facebook.com/profile.php?id=61589307333290" target="_blank" rel="noreferrer" aria-label="Facebook" className="p-2 rounded-full border border-cometa-crema/20 hover:bg-cometa-crema hover:text-cometa-tinta transition"><Facebook size={18} /></a>
            <a data-testid="social-youtube" href="https://www.youtube.com/@dracometa" target="_blank" rel="noreferrer" aria-label="YouTube" className="p-2 rounded-full border border-cometa-crema/20 hover:bg-cometa-crema hover:text-cometa-tinta transition"><Youtube size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-cometa-crema/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cometa-crema/50">
          <p>© {new Date().getFullYear()} Dra. Cometa · Araceli Lugo. Todos los derechos reservados.</p>
          <div className="flex gap-6">
            <Link to="/privacidad" className="link-underline">Privacidad</Link>
            <Link to="/terminos" className="link-underline">Términos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
